import ReactCountryFlag from "react-country-flag";
import { Track } from "../../interfaces/dtos/track";
import { countriesFromList } from "./sharedHelper";
import { Box, useTheme } from "@mui/material";
import { getCountryCodeForFlag } from "../../utils/commonUtils";
import { statusItems } from "../track/trackPage/trackPageHelper";
import { useAppSelector } from "../../redux/hooks";
import { commonState } from "../../redux/common/commonSlice";

export const GetCountryOptions = (tracks: Track[] | undefined, selectedCountry?: string) => {
    const common = useAppSelector(commonState);
    const countries = common.countries;

    return countriesFromList(countries,
        tracks ? tracks.map(t => t.countryCode!) : countries.map(c => c.code),
        selectedCountry)
        .map((c) => ({
            value: c.code,
            filter: `${c.code} ${c.name}`,
            description:
                <Box sx={{ display: 'flex' }}>
                    <ReactCountryFlag
                        countryCode={getCountryCodeForFlag(c.code)}
                        svg
                        style={{ fontSize: '20px' }}
                    />
                    <Box sx={{ paddingLeft: '10px' }}>{c.name}</Box>
                </Box>
        }));
}

export const GetStatusOptions = () => {
    const theme = useTheme();

    return statusItems.map(c => ({
        value: c.key,
        description:
            <Box sx={{ color: c.key === 'A' ? theme.palette.success.main : theme.palette.warning.main }}>
                {c.value}
            </Box>
    }));
}
